// utilities
import api from '@/utilities/api'
export const getVehicles = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/vehicles',
    success (response) {
      commit('setVehicles', response.data)
    }
  })
}
export const createVehicle = ({ rootState, commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/vehicles',
    payload,
    success (response) {
      dispatch('getVehicles')
      rootState.facilities.searchCriteria.vehicleID = response.data.vehicleID
    }
  })
}
export const deleteVehicle = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/vehicles/' + payload.vehicleID,
    success (response) {
      dispatch('getVehicles')
    }
  })
}
